<template>
  <div>
    <div class="reset">
      <ValidationObserver
        v-slot="{ invalid }"
        ref="observer"
        tag="form"
        name="userLoginForm"
        class="form"
        @submit.prevent="validateBeforeSubmit()"
      >
        <InputText
          v-model="form.mail"
          :vid="'mail'"
          :label="'認証メールアドレス'"
          :type="'email'"
          :maxlength="255"
          rules="required|email|max:255"
          class="form__group"
        />

        <!-- Submit Button -->
        <div class="form__group mt72">
          <Btn
            :label="'パスワードのリセット'"
            :color="'red'"
            :disabled="invalid || isLoading"
            :type="'submit'"
          />
        </div>
      </ValidationObserver>
    </div>
  </div>
</template>

<script>
import {mapGetters} from 'vuex'
import store from '@/store'
import error from '@/mixin/error.mixin'
import InputText from '@/components/parts/InputText'
import Btn from '@/components/parts/Btn'

export default {
  name: 'PasswordForgotStep01Mail',

  mixins: [error],

  components: {
    mapGetters,
    InputText,
    Btn
  },

  computed: {
    ...mapGetters(['isLoading'])
  },

  data () {
    return {
      form: {
        mail: ''
      }
    }
  },

  beforeRouteEnter (from, to, next) {
    store.commit('loadingAction', false)
    next()
  },

  methods: {
    async validateBeforeSubmit () {
      const isValid = await this.$refs.observer.validate()
      if (isValid) {
        store.commit('loadingAction', true)
        store.dispatch('passwordForgot/sendForgotMail', {
          mail: this.form.mail
        }).then((_res) => {
          store.commit('loadingAction', false)
          this.$router.push({
            name: 'PasswordForgotCode',
            params: { id: _res.code_request_id }
          }).catch(() => {})
        }).catch((err) => {
          store.commit('loadingAction', false)
          this.addValidateErrors(this.$refs.observer, err)
        })
      }
    }
  }
}
</script>
<style lang="postcss" scoped>
  @import '../../assets/css/common.css';
  @import '../../assets/css/form.pcss';

  .reset {
    height: 100%;
    overflow: auto;
    margin-top: 50px;
    .form {
      padding-top: 50px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/password-forgot/Step01Mail.vue